<template>
	<div class="layer-content common">
		<div class="box-type02">
			<div class="__layer-type-dt">
				<div class="entry-tit"><div class="img-com __icon07"><span>안내 아이콘</span></div><span>이 어린이집은 이미 다른 회원님이 등록하셨습니다.</span></div>
				<ul class="txt-type1 depth2 mgt30">
					<li>서비스 신청하시는 분이 교직원인 경우는 <span class="pc01">원장선생님께 아이디 연결을 요청</span>하세요.</li>
					<li>서비스 신청하시는 분이 원장님인 경우는 <span class="pc01">1대1 문의 또는 고객센터로 연락</span>주시면<br />확인 작업 후 가입을 진행하실 수 있도록 안내해드리겠습니다.</li>
				</ul>
				<div class="box-type07 pd20 mgt20 __center bold" style="font-size:16px;"><div class="img-com __icon13"><span>안내 아이콘</span></div>고객센터 연락처 : 1661-5029</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name : 'searchFcltOvrlpPopup'
}
</script>